// extracted by mini-css-extract-plugin
module.exports = {"disc":"e_dT","accent":"e_eT","empty":"e_fT","s32":"e_gT","s36":"e_hT","s44":"e_iT","s56":"e_jT","s72":"e_kT"};